import { useAuthStore } from "@/state/pinia";

export default [
  {
    path: "/",
    name: "default",
    meta: { title: "Dashboard", authRequired: true },
    component: () => import("../views/dashboards/default.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        // If the user is already logged in
        // if (store.getters["auth/loggedIn"]) {
        if (auth.userLogin) {
          window.location.href = "/";
          next({ name: "default" });
        } else {
          window.location.href = "/login";
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        // If the user is already logged in
        // if (store.getters["auth/loggedIn"]) {
        if (auth.loggedIn) {
          window.location.href = "/";
          next({ name: "default" });
        } else {
          window.location.href = "/login";
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password"),
    meta: {
      title: "Forgot password",
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        // If the user is already logged in
        // if (store.getters["auth/loggedIn"]) {
        if (auth.loggedIn) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          window.location.href = "/login";
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/account/logout"),
    meta: {
      title: "Logout",
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();

        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          auth.logOut();
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  // {
  //   path: "*",
  //   redirect: "404",
  // }
  {
    path: "/users",
    name: "users",
    component: () => import("../views/users/index.vue"),
    meta: {
      title: "User",
      authRequired: true
    },
  },
  {
    path: "/categories",
    name: "categories",
    component: () => import("../views/category/index.vue"),
    meta: {
      title: "Category",
      authRequired: true
    },
  },
  {
    path: "/tags",
    name: "tags",
    component: () => import("../views/tag/index.vue"),
    meta: {
      title: "Tag",
      authRequired: true
    },
  },
  {
    path: "/show-more",
    name: "show-more",
    component: () => import("../views/guest/show-more.vue"),
    meta: {
      title: "Article",
      authRequired: false,
    },
  },
  {
    path: "/article/:slug",
    name: "article",
    component: () => import("../views/guest/detail-article.vue"),
    meta: {
      title: "Article",
      authRequired: true,
    },
  },
  {
    path: "/trashed-article",
    name: "trashed",
    component: () => import("../views/article/trashed-article.vue"),
    meta: {
      title: "Article",
      authRequired: true
    },
  },
  {
    path: "/articles/creator",
    name: "creator",
    component: () => import("../views/article/index-creator.vue"),
    meta: {
      title: "Creator",
      authRequired: true
    },
  },
  {
    path: "/articles/verifier",
    name: "verifier",
    component: () => import("../views/article/index-verifier.vue"),
    meta: {
      title: "Verifier",
      authRequired: true
    },
  },
  {
    path: "/articles/add-articles",
    name: "add-articles",
    component: () => import("../views/article/form.vue"),
    meta: {
      title: "Add Article",
      authRequired: true
    },
  },
  {
    path: "/articles/edit-articles",
    name: "edit-articles",
    component: () => import("../views/article/form.vue"),
    meta: {
      title: "Edit Article",
      authRequired: true
    },
  },
];
